import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function ProblemSection() {
  const {
    t
  } = useLanguage();
  return <section className="relative w-full py-8 sm:py-14 overflow-hidden" data-id="element-225">
      {/* Decorative orb */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-purple-electric/[0.04] rounded-full blur-[120px] pointer-events-none" data-id="element-226" />

      <div className="relative max-w-3xl mx-auto px-6 text-center" data-id="element-227">
        {/* Accent line */}
        <motion.div initial={{
        scaleX: 0
      }} whileInView={{
        scaleX: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        ease: [0.22, 1, 0.36, 1]
      }} className="w-16 h-px bg-gradient-to-r from-transparent via-purple-electric to-transparent mx-auto mb-5 sm:mb-8" data-id="element-228" />

        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1]
      }} className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-4 sm:mb-6" data-id="element-229">
          {t('problem.title.part1')}{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-electric to-astral" data-id="element-230">
            {t('problem.title.part2')}
          </span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="space-y-5" data-id="element-231">
          <p className="font-sans text-lg text-white/40 leading-relaxed" data-id="element-232">
            {t('problem.description')}
          </p>
        </motion.div>

        {/* Bottom accent */}
        <motion.div initial={{
        scaleX: 0
      }} whileInView={{
        scaleX: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.4,
        ease: [0.22, 1, 0.36, 1]
      }} className="w-16 h-px bg-gradient-to-r from-transparent via-purple-electric/50 to-transparent mx-auto mt-5 sm:mt-8" data-id="element-233" />
      </div>
    </section>;
}